import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CreatePermissionSetWrapper = lazy(() =>
  import("@scenes/PermissionSettings/components/CreatePermissionSet/CreatePermissionSetWrapper").then((module) => ({
    default: module.CreatePermissionSetWrapper,
  }))
);

export const newPermissionSettingsPermissionSetNRO: NavigationRoutingObject = {
  Component: CreatePermissionSetWrapper,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("new-permission-set-nro-heading", "New Permission Set"),
  pageNameForTracking: () => "New Permission Set",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "manageCompanySettings",
    });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/permission_sets/:appGroupId",
};
